import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgFeatureFlagsModule } from '@principle-theorem/ng-feature-flags';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import { NgPrincipleModule } from '@principle-theorem/ng-principle';
import { NgPrincipleSharedModule } from '@principle-theorem/ng-principle-shared';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { StaffListComponent } from './staff-list/staff-list.component';
import { StafferEditComponent } from './staffer-edit/staffer-edit.component';

@NgModule({
  declarations: [StaffListComponent, StafferEditComponent],
  imports: [
    NgMaterialModule,
    NgSharedModule,
    RouterModule,
    ReactiveFormsModule,
    NgFeatureFlagsModule,
    NgPrincipleModule,
    NgPrincipleSharedModule,
  ],
  exports: [StafferEditComponent],
})
export class StaffModule {}
